var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container responsive-height"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","xl":"12"}},[_c('LiveTradeTabs')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }